import { useEffect, useState } from "react";
import styles from "./CandidatePage.module.css";
import useNotification from "../../../hooks/useNotification";
import React from "react";
import { CANDIDATE } from "../../../urlConfig";
import CustomBreadcrumb from "../../CommonComponents/CustomBreadcrumb";
import CompanyDetails from "./CompanyDetails";
import CompanyDetails2 from "./CompanyDetails2";
import { useLocation } from "react-router-dom";
import CandidateServices from "../../../services/CandidateServices";

const CandidatePage = () => {
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState({});
  const location = useLocation();

  const BreadcrumbOptions = [
    {
      title: "Candidate",
      link: CANDIDATE,
    },
    {
      title: companyData.firstName + " " +companyData.lastName || "Candidate Name",
    },
  ];

  useEffect(() => {
    fetchUserOverviewData();
  }, []);

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const fetchUserOverviewData = async () => {
    setLoading(true);
    console.log("location.pathname.split()[0]", location.pathname.split("/")[2])
    const res = await CandidateServices.getCandidateById(
      location.pathname.split("/")[2]
    );

    if (res) {
      if (res.statusCode === 1) {
        setCompanyData(res.data);
      } else {
        handleError(`${res.statusDesc}`);
      }
    } else {
      handleError(`Error: ${res.statusDesc}`);
    }
    setLoading(false);
  };

  return (
    <div className={styles.page_wrap}>
      <CustomBreadcrumb options={BreadcrumbOptions} />
      <CompanyDetails
        data={companyData}
        loading={loading}
        refatchData={fetchUserOverviewData}
      />
      <CompanyDetails2
        data={companyData}
        loading={loading}
        refatchData={fetchUserOverviewData}
      />
    </div>
  );
};

export default CandidatePage;
